import {
  CenterContainer,
  LeftContainer,
  FlexibleRowContainer,
} from "../../styles/styles";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

export const SmallSkeletonListItem = () => {
  return (
    <FlexibleRowContainer style={{ padding: "20px 24px" }}>
      <LeftContainer>
        <FixaSkeleton height={"24px"} width={"24px"} />
      </LeftContainer>
      <CenterContainer $centerText={false} style={{ gap: "5px" }}>
        <FixaSkeleton height={"14px"} width={"164px"} />
        <FixaSkeleton height={"14px"} width={"71px"} />
      </CenterContainer>
    </FlexibleRowContainer>
  );
};
